module.exports = __webpack_public_path__ + "img/default-crypto.95f83a18.svg";